import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import api, { imgUrl } from "../lib/api";

export default function OfferPopup() {
  const [promo, setPromo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("editor") === "1" || params.get("preview") === "1") return undefined;
    let timer;
    api.get("/campaigns/promo").then((r) => {
      const p = r.data;
      if (!p?.id || !p.show_popup) return;
      if (sessionStorage.getItem(`hc-promo-${p.id}`)) return;
      timer = setTimeout(() => { setPromo(p); setOpen(true); }, 2500);
    }).catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setOpen(false);
    if (promo?.id) sessionStorage.setItem(`hc-promo-${promo.id}`, "1");
  };

  return (
    <AnimatePresence>
      {open && promo && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-40 bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:w-[360px] bg-[#111111] text-[#FAF9F6] border border-gold/40 shadow-2xl"
          data-testid="offer-popup"
          role="dialog"
          aria-label="Special offer"
        >
          {promo.popup_image && (
            <img src={imgUrl(promo.popup_image)} alt={promo.title || promo.name} className="w-full aspect-[16/9] object-cover" />
          )}
          <button onClick={close} aria-label="Close offer" data-testid="offer-popup-close"
            className="absolute top-3 right-3 bg-[#111111]/70 backdrop-blur p-1.5 hover:text-gold transition-colors duration-300">
            <X strokeWidth={1.5} size={16} />
          </button>
          <div className="p-6">
            <p className="small-caps text-gold mb-2">Special Offer</p>
            <p className="font-serif text-2xl leading-tight" data-testid="offer-popup-title">{promo.title || promo.name}</p>
            {promo.description && <p className="text-xs text-[#A3A3A3] mt-2 leading-relaxed">{promo.description}</p>}
            <div className="flex items-center gap-5 mt-5">
              <Link to={promo.cta_link || "/shop"} onClick={close}
                className="bg-gold text-[#111] px-6 py-2.5 small-caps hover:bg-[#FAF9F6] transition-colors duration-300"
                data-testid="offer-popup-cta">
                {promo.cta_text || "Shop Now"}
              </Link>
              <button onClick={close} className="text-[11px] uppercase tracking-widest text-[#A3A3A3] hover:text-gold transition-colors duration-300" data-testid="offer-popup-dismiss">
                No thanks
              </button>
            </div>
            {promo.end_at && (
              <p className="text-[10px] text-[#737373] mt-4">Ends {new Date(promo.end_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
